import * as React from "react";
import { Loading, isLoading } from "../../Loading";
import "./StatusComponent.css";
import { Intent, Spinner, Tooltip } from "@blueprintjs/core";

interface StatusComponentProps {
    questionStatus: boolean | Loading | null;
}

export class StatusComponent extends React.Component<StatusComponentProps> {
    constructor(props: StatusComponentProps) {
        super(props);
    }

    render() {
        if (this.props.questionStatus !== null) {
            return (
                <div
                    style={{
                        width: "20px",
                        height: "20px",
                        marginLeft: "10px"
                    }}
                >
                    {
                        isLoading(this.props.questionStatus) ?
                            <div className={"StatusComponent__answerLoading"}>
                                <Spinner intent={Intent.PRIMARY} className={"bp3-small"}/>
                            </div>
                            :
                            this.props.questionStatus ?
                                <div className="StatusComponent__answerCorrect"/>
                                :
                                <div>
                                    <div className="StatusComponent__answerWrong" data-tip={true} data-for="errorToolTip"/>
                                </div>
                    }
                </div>
            );
        }
        return null;

    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/StatusComponent.tsx